import React from 'react';
import Slider, { CustomArrowProps } from 'react-slick';
import { Link } from 'react-router-dom';

import { ImageResizer } from '../../Types/ImageResizer';

import { ReactComponent as CircleArrowRightIcon } from '../Icons/circleArrowRight.svg';
import { ReactComponent as CircleArrowLleftIcon } from '../Icons/circleArrowLeft.svg';
import { ReactComponent as ArrowRight } from '../Icons/arrowRight.svg';

import './Expertise.scss';
import { useSessionStorage } from '../../hooks/useSessionStorage';

interface ExpertiseProps {
	headTitle: string;
	headTitleUa: string;
	subTitle?: string;
	subTitleUa?: string;
	expertiseTiles: {
		title: string;
		titleUa: string;
		subTitle: string;
		subTitleUa: string;
		image: ImageResizer;
		buttonText: string;
		buttonTextUa: string;
		slug: string;
	}[];
}

const PrevArrow = ({ onClick }: CustomArrowProps) => {
	return (
		<div className="leftArrow" onClick={onClick}>
			{' '}
			<CircleArrowLleftIcon />{' '}
		</div>
	);
};

const NextArrow = ({ onClick }: CustomArrowProps) => {
	return (
		<div className="rightArrow" onClick={onClick}>
			{' '}
			<CircleArrowRightIcon />{' '}
		</div>
	);
};

const settings = {
	infinite: true,
	centerPadding: '0px',
	slidesToShow: 1,
	speed: 500,
	prevArrow: <PrevArrow />,
	nextArrow: <NextArrow />,
};

export default function Expertise({ expertiseTiles, headTitle, headTitleUa, subTitle, subTitleUa }: ExpertiseProps) {
	const [language] = useSessionStorage('language', '');

	return (
		<div data-testclass="expertiseSection" id="expertiseSection" className="expertiseContent">
			<div className="expertiseTitle">{language === 'ua' ? headTitleUa : headTitle}</div>
			{subTitle && <div className="expertiseSubTitle">{language === 'ua' && subTitleUa ? subTitleUa : subTitle}</div>}
			<Slider {...settings}>
				{expertiseTiles.map((tile, index) => (
					<div key={index} className={tile.slug ? 'expertiseTile' : 'shortExpertiseTile'}>
						<div
							className="expertiseTileImage"
							style={{
								backgroundImage: tile.image && `url(${tile.image.sm.src})`,
							}}
						/>
						<div className="expertiseTileContentWrapper">
							<div className="expertiseTileContent">
								<div className="expertiseTileTitle">{language === 'ua' ? tile.titleUa : tile.title}</div>
								<div className="expertiseTileSubTitle">{language === 'ua' ? tile.subTitleUa : tile.subTitle}</div>
							</div>
							{tile.slug && (
								<Link to={`/service/${tile.slug}`} className="expertiseTileButton">
									<span>{language === 'ua' ? tile.buttonTextUa : tile.buttonText}</span>
									<ArrowRight />
								</Link>
							)}
						</div>
					</div>
				))}
			</Slider>
		</div>
	);
}
